<template>
  <div id="myPurchase">
    <!--导航栏-->
    <van-nav-bar
      :title="title"
      left-text="返回"
      left-arrow
      :fixed="true"
      :border="true"
      @click-left="onClickLeft"
    >
      <template #right v-if="showRefresh">
        <div
          v-if="$route.meta.add"
          name="replay"
          size="18"
          @click="add"
          class="add"
        >
          {{ $route.meta.addText || "新增" }}
        </div>
        <van-icon v-else name="replay" size="18" @click="refresh" />
      </template>
    </van-nav-bar>
    <transition name="router-slider" mode="out-in">
      <router-view style="padding-top: 46px"></router-view>
    </transition>
  </div>
</template>
<script>
export default {
  name: "index",
  data() {
    return { title: "零售管理" };
  },
  computed: {
    showRefresh() {
      return this.$route.path !== "/retail/manual-outbound";
    },
  },
  created() {},
  watch: {
    $route: {
      handler(to) {
        this.title = to.meta.title;
      },
      immediate: true,
      deep: true,
    },
  },
  methods: {
    refresh() {
      location.reload();
    },
    add() {
      const action = this.$route.meta.addAction;
      if (action) action(this.$router);
    },
    onClickLeft() {
      if (this.$route.meta.prev) {
        this.$router.replace(this.$route.meta.prev);
        return;
      }
      this.$router.back();
    },
  },
};
</script>
<style scoped lang="less">
.van-nav-bar--fixed {
  position: fixed !important;
}
</style>
